import { Brand, SbCreative, SBStrategy, State } from "@front/m19-api-client";
import { BrandNameMaxLength } from "@front/m19-models/SbLimits";
import type { SbFormAssetsModel } from "@m19-board/strategies/sb-create-strategy/steps/sb-form-assets/sb-form-assets.component";
import type { SbFormFormatModel } from "@m19-board/strategies/sb-create-strategy/steps/sb-form-format/sb-form-format.component";

export function buildSbCreative(input: {
  strategy: SBStrategy;
  assets: SbFormAssetsModel;
  format: SbFormFormatModel;
  setupBrand: Brand | null;
}): SbCreative {
  const { strategy, assets, format, setupBrand } = input;
  const brandName = assets.brandName || setupBrand?.brandName?.substring(0, BrandNameMaxLength) || "";
  return {
    creativeId: -1,
    strategyId: strategy.strategyId!,
    accountId: strategy.accountId,
    marketplace: strategy.marketplace,
    brandEntityId: setupBrand?.brandEntityId ?? strategy.brandEntityId,
    brandName,
    logoAssetId: assets.brandLogo?.assetId,
    headline: assets.headline?.trim() || "",
    storePageId: format.store?.storePageId,
    videoAssetId: assets.video?.assetId,
    creativeAsins: [],
    state: State.ON,
    creativeType: format.sbCreativeType,
  };
}
